module.exports = __webpack_public_path__ + "media/images/png/rent/3-39921c889daa3a718d357fe1e745aac2.png";